export const normalizePricePair = (minimum, maximum) => {
    const parse = (value) => {
        const normalized = String(value ?? '').trim().replace(',', '.');
        const number = Number.parseFloat(normalized);

        return Number.isFinite(number) && number >= 0 ? number : null;
    };
    const min = parse(minimum);
    const max = parse(maximum);

    if (min !== null && max !== null && min > max) {
        return [max, min];
    }

    return [min, max];
};

export const nextGridMode = (currentMode) => (currentMode === 'relaxed' ? 'default' : 'relaxed');

export const safeStoredGridMode = (value) => (value === 'relaxed' ? 'relaxed' : 'default');

export const priceRangePercent = (value, minimum, maximum) => {
    const current = Number(value);
    const lower = Number(minimum);
    const upper = Number(maximum);

    if (![current, lower, upper].every(Number.isFinite) || upper <= lower) {
        return 0;
    }

    return Math.min(100, Math.max(0, ((current - lower) / (upper - lower)) * 100));
};

export const archiveModelLabel = (value) => {
    const total = Math.max(0, Math.floor(Number(value) || 0));

    if (total === 1) {
        return 'MODEL';
    }

    const lastTwo = total % 100;
    const last = total % 10;

    return last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)
        ? 'MODELE'
        : 'MODELI';
};

export const createArchiveCountRequestUrl = (
    endpoint,
    entries = [],
    { taxonomy = '', termId = 0 } = {},
    baseUrl = 'http://localhost/',
) => {
    const url = new URL(String(endpoint || ''), baseUrl);
    const supportedName = /^(s|category\[\]|collection\[\]|attribute\[[a-z0-9_-]+\]\[\]|on_sale|min_price|max_price)$/;

    for (const [name, value] of entries) {
        if (supportedName.test(String(name)) && String(value) !== '') {
            url.searchParams.append(String(name), String(value));
        }
    }

    if (taxonomy && Number(termId) > 0) {
        url.searchParams.set('archive_taxonomy', String(taxonomy));
        url.searchParams.set('archive_term_id', String(Math.floor(Number(termId))));
    }

    return url.toString();
};

export const createArchiveNavigationUrl = (
    action,
    entries = [],
    baseUrl = 'http://localhost/',
) => {
    const url = new URL(String(action || baseUrl), baseUrl);
    url.search = '';
    url.hash = '';

    for (const [name, value] of entries) {
        const key = String(name || '');
        const normalizedValue = String(value ?? '');

        if (key && normalizedValue !== '') {
            url.searchParams.append(key, normalizedValue);
        }
    }

    return url.toString();
};
